import React, { useState, useEffect } from "react";
import { Container, Card, CardBody } from "reactstrap";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import apiClient from "../../axiosInstance";
import TanstackTable from "../../components/Common/TanstackTable";
import Breadcrumbs from "../../components/Common/Breadcrumb";

const VehiclesList = () => {
  const [breadcrumbItems] = useState([
    { title: "Daryeel", link: "/" },
    { title: "Vehicles List", link: "#" },
  ]);

  const [data, setData] = useState([]);

  const fetchVehicles = async () => {
    try {
      const result = await apiClient.get("/vehicles/getvehicles");
      const response = result.data;
      setData(response);
      console.log("Vehicles data:", response);
    } catch (err) {
      console.error("Error fetching users:", err);
    }
  };

  useEffect(() => {
    fetchVehicles();
  }, []);

  const handleDeleteVehicle = async (vehicleId) => {
    const confirmResult = await Swal.fire({
      title: "Delete Vehicle?",
      text: "Are you sure you want to delete this vehicle?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete",
      cancelButtonText: "Cancel",
    });

    if (!confirmResult.isConfirmed) {
      return;
    }

    try {
      const response = await apiClient.delete(
        `/vehicles/delete-vehicles/${vehicleId}`
      );

      if (response.data.status === "success") {
        setData((prevData) =>
          prevData.filter((vehicle) => vehicle.id !== vehicleId)
        );
        await Swal.fire({
          title: "Deleted",
          text: response.data.message || "Vehicle deleted successfully",
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
        });
        return;
      }

      await Swal.fire({
        title: "Delete Failed",
        text: response.data.message || "Failed to delete vehicle",
        icon: "error",
      });
    } catch (error) {
      console.error("Error deleting vehicle:", error);
      const errorMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Failed to delete vehicle";
      await Swal.fire({
        title: "Error",
        text: errorMessage,
        icon: "error",
      });
    }
  };

  const columns = [
    {
      id: "index",
      header: "No",
      cell: ({ row }) => row.index + 1,
    },
    {
      accessorKey: "license_plate",
      header: "License No",
    },
    {
      accessorKey: "vin",
      header: "VIN No",
    },
    {
      accessorKey: "make_name",
      header: "Manufacturer",
    },
    {
      header: "Model",
      cell: ({ row }) => (
        <>
          {row.original.model_name}
          {row.original.color ? ` - ${row.original.color}` : ""}
          {row.original.year_of_manufacture
            ? `(${row.original.year_of_manufacture})`
            : ""}
        </>
      ),
    },
    {
      accessorKey: "status",
      header: "Status",
    },
    {
      id: "actions",
      header: "Actions",
      cell: ({ row }) => (
        <div className="d-flex gap-2">
          <Link
            to={`/updateVehicle/${row.original.id}`}
            className="btn btn-sm btn-primary"
          >
            <i className="ri-file-edit-line"></i>
          </Link>
          <button
            type="button"
            className="btn btn-sm btn-danger"
            onClick={() => handleDeleteVehicle(row.original.id)}
          >
            <i className="ri-delete-bin-line"></i>
          </button>
        </div>
      ),
    },
  ];
  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Vehicles List" breadcrumbItems={breadcrumbItems} />
        <Card>
          <CardBody>
            <div className="row">
              <div className="col-12 text-end mb-2">
                <Link to="/createVehicle">
                  <button className="btn btn-primary">Create Vehicle</button>
                </Link>
              </div>
            </div>
            <TanstackTable data={data} columns={columns} />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default VehiclesList;
